import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 300
    },
    width: {
      type: Number,
      default: 300
    },
    poster: {
      type: String,
      default: ''
    },
    muted: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: [String, Number],
      default: 0
    }
  },
  data: function data() {
    return {
      playerOptions: {
        muted: this.muted,
        autoplay: this.autoplay,
        language: 'zh-CN',
        width: this.width,
        height: this.height,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          src: this.src
        }],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        poster: this.poster,
        alwaysCaptureHotkeys: true,
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      }
    };
  },
  computed: {},
  created: function created() {
    // window.HELP_IMPROVE_VIDEOJS = false
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    playerReadied: function playerReadied(player) {
      player.hotkeys({
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
        alwaysCaptureHotkeys: true,
        playPauseKey: function playPauseKey(event, player) {
          if (player.isFullscreen()) {
            player.el().focus();
          }
          return event.which === 32 || event.which === 179;
        },
        fullscreenKey: function fullscreenKey(event) {
          return event.which === 70;
        }
      });
      player.currentTime(this.currentTime);
    },
    onPlayerTimeupdate: function onPlayerTimeupdate(e) {
      var currentTime = parseInt(e.currentTime());
      this.$emit('timeupdate', currentTime);
    }
  }
};